module.exports = __webpack_public_path__ + "static/media/wildflowersMeadows.f76590ed.svg";